/**
 * Hook for creating Grida editor handoff URL
 * 
 * Calls backend to generate one-time token and returns the consume URL
 */

import { useMutation } from "@tanstack/react-query";
import { frappe } from "@/lib/frappe-client";
import { logger } from "@/lib/utils/logger";

interface HandoffResponse {
  url?: string;
  error?: string;
}

/**
 * Hook to create Grida editor handoff URL
 * 
 * Returns a mutation that can be called with pageConfigName to get the handoff URL
 */
export function useGridaEditorHandoff() {
  return useMutation<HandoffResponse, Error, string>({
    mutationFn: async (pageConfigName: string) => {
      try {
        const result = await frappe.call<HandoffResponse>(
          "zaviago_backend.storefront.grida_editor.create_grida_editor_handoff",
          { page_config_name: pageConfigName }
        );
        return result;
      } catch (error) {
        logger.error("[useGridaEditorHandoff] Failed to create handoff:", error);
        throw error;
      }
    },
  });
}
